import { mergeStyleSets } from "@fluentui/react";

export const gapStyles = mergeStyleSets({
  flexColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
  },
  gap32: {
    gap: 32,
  },
  gap8: {
    gap: 8,
  },
  gap16: {
    gap: 16,
  },
  gap4: {
    gap: 4,
  },
});
